import { render, staticRenderFns } from "./LayoutInfo.vue?vue&type=template&id=5e7b16a0&scoped=true"
import script from "./LayoutInfo.vue?vue&type=script&lang=ts"
export * from "./LayoutInfo.vue?vue&type=script&lang=ts"
import style0 from "./LayoutInfo.vue?vue&type=style&index=0&id=5e7b16a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7b16a0",
  null
  
)

export default component.exports